import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CognitoService } from 'app/shared/services/cognito.service';

export const isIndagoAiTenantGuard: CanActivateFn = async () => {
  const cognitoService = inject(CognitoService);
  const router = inject(Router);

  try {
    const session = await cognitoService.getCurrentSession();
    if (session?.companyId === 'indagoai') {
      return true;
    }
  } catch {
    // Session retrieval failed
  }

  router.navigate(['/not-found']).then(() => {});
  return false;
};
